<template>
  <div>
    <div class="message intent-box-verify-slip">
      <div>
        <template>
          <div class="form-control-wrapper">
            <div
              class="form-control"
              :class="{
                'has-error': errors.has(
                  'answer_' + (indexAlternative - 1) + type + '_text_' + index
                )
              }"
            >
              <autoresize-textarea
                maxlength="2000"
                :ref="'answer_' + (indexAlternative - 1) + type + '_' + index"
                class
                :placeholder="$t('Chatbot answers')"
                v-model.trim="input"
                name="answer"
                data-vv-as="Answer"
                :data-vv-name="'answer_' + (indexAlternative - 1) + type + '_text_' + index"
                v-validate
                style="resize: none; display: inherit; margin-bottom: 5px;min-width: 200px; height: 400px"
                :key="`product_${timestamp}_${index}`"
              ></autoresize-textarea>
              <v-layout>
                <v-flex class="error--text">
                  {{ errors.first('answer_' + (indexAlternative - 1) + type + '_text_' + index) }}
                </v-flex>
                <v-flex shrink class="text-xs-right caption grey--text">
                  {{ input.length }}/2000
                </v-flex>
              </v-layout>
            </div>
          </div>
        </template>
      </div>
      <div class="clearfix"></div>

      <small
        class="caption warning--text"
        v-if="!isLineShopping && (channel === 'all' || ['instagram'].includes(channel))"
      >
        * {{ $t('instagram_1000_characters') }}
      </small>
    </div>
    <intent-prefill
      :isIntent="true"
      @addIntentPrefillGroup="addIntentPrefill($event, isGroup)"
      @addIntentPrefill="addIntentPrefill($event)"
    ></intent-prefill>
  </div>
</template>

<script>
import AutoresizeTextarea from '../../view/livechat/AutoresizeTextarea.vue'
import IntentPrefill from './IntentPrefill'

export default {
  components: {
    AutoresizeTextarea,
    IntentPrefill
  },
  props: {
    value: {
      type: String
    },
    type: {
      type: String
    },
    isLineShopping: {
      type: Boolean,
      default: () => false
    },
    channel: {
      type: String
    },
    index: {
      type: Number,
      default: () => 0
    },
    indexAlternative: {
      type: Number,
      default: () => 0
    },
    timestamp: {
      type: [String, Number],
      default: () => null
    }
  },
  computed: {
    input: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    addIntentPrefill(value, isGroup) {
      const input = this.$refs[
        'answer_' + (this.indexAlternative - 1) + this.type + '_' + this.index
      ]
      let cursorPosition = input.$el.selectionStart
      this.input = [
        this.input.slice(0, cursorPosition),
        isGroup ? value : '{' + value + '}',
        this.input.slice(cursorPosition)
      ].join('')
    }
  }
}
</script>

<style lang="scss" scoped>
.intent-box-verify-slip {
  float: left;
  max-width: 240px;
  overflow-wrap: break-word;
  min-height: 22px;
  min-width: 14px;
  line-height: 15.36px;
  overflow: hidden;
  cursor: pointer;
  font-size: 12px;
  margin: 0 30px;
  color: black;
}

.form-control-wrapper {
  border-radius: 12px;
  padding: 8px 6px 2px;
  background-color: #f1f0f0;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentVerifySlipItem.vue